import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
// import EditAndDuplicateCampaignsModal from './EditAndDuplicateCampaignsModal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import useRequest from '../../../Hooks/useRequest';
import usePost from '../../../Hooks/usePost';
import AddUsersModal from './AddUsersModal';

const ViewUsersContainer = styled.div`
    margin-top: 100px;
    display: flex;
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: 500px;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const StyledDuplicateButton = styled.div`
    cursor: pointer;
`;

const ViewUsers = (props) => {
    const { advertisers, profile } = props;

    const [tableRows, setTableRows] = useState([]);
    const [postData, setPostData] = useState({
        success: false,
        error: false,
        isLoading: false,
        message: [''],
    });

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [advertiserData, setAdvertiserData] = useState({
        isAgencyPrimary: false,
        isAgencyManager: false,

        companyName: '',
        companyWebsite: '',
        firstName: '',
        lastName: '',
        title: '',
        primaryPhone: '',
        mobilePhone: '',
        streetAddress: '',
        country: '',
        city: '',
        province: '',
        zipCode: '',
    });

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
    };

    const history = useHistory();

    const createData = (
        isAgencyPrimary,
        isAgencyManager,
        companyName,
        companyWebsite,
        firstName,
        lastName,
        email,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        country,
        city,
        province,
        zipCode
    ) => {
        return {
            isAgencyPrimary,
            isAgencyManager,
            companyName,
            companyWebsite,
            firstName,
            lastName,
            email,
            title,
            primaryPhone,
            mobilePhone,
            streetAddress,
            country,
            city,
            province,
            zipCode,
        };
    };

    const data = [
        {
            isAgencyPrimary: false,
            isAgencyManager: false,
            companyName: 'Tesla',
            companyWebsite: 'Tesla.com',
            firstName: 'AJ',
            lastName: 'Hosny',
            title: 'DEV',
            email: 'ajhosny@gmail.com',
            primaryPhone: '6109054171',
            mobilePhone: '6109054171',
            streetAddress: '1197 winter lane',
            country: 'US',
            city: 'easton',
            province: 'PA',
            zipCode: '18040',
        },
        {
            isAgencyPrimary: false,
            isAgencyManager: false,
            companyName: 'Tesla',
            companyWebsite: 'Tesla.com',
            firstName: 'Elon',
            lastName: 'Musk',
            email: 'ajhosny@gmail.com',
            title: 'DEV',
            primaryPhone: '6109054171',
            mobilePhone: '6109054171',
            streetAddress: '1197 winter lane',
            country: 'US',
            city: 'easton',
            province: 'PA',
            zipCode: '18040',
        },
    ];

    const addDataToRows = () => {
        const rows = [];
        if (data && data.length > 0) {
            data.map((item) => {
                rows.push(
                    createData(
                        item.isAgencyPrimary,
                        item.isAgencyManager,
                        item.companyName,
                        item.companyWebsite,
                        item.firstName,
                        item.lastName,
                        item.email,
                        item.title,
                        item.primaryPhone,
                        item.mobilePhone,
                        item.streetAddress,
                        item.country,
                        item.city,
                        item.province,
                        item.zipCode
                    )
                );
            });

            setTableRows(rows);
        } else {
            setTableRows([]);
        }
    };

    const handleClose = () => {
        setModalIsOpen(false);
    };

    useEffect(() => {
        addDataToRows();
    }, []);

    const noAdvertisers = data.length === 0;

    return (
        <>
            <ViewUsersContainer>
                <Title>View Users</Title>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Company Name</TableCell>
                                <TableCell align="right">First Name</TableCell>
                                <TableCell align="right">Last Name</TableCell>
                                <TableCell align="right">Email</TableCell>
                                <TableCell align="right">Title</TableCell>
                                <TableCell align="right">Company Website</TableCell>
                                <TableCell align="right">Primary Phone</TableCell>
                                <TableCell align="right">Mobile Phone</TableCell>
                                <TableCell align="right">Street Address </TableCell>
                                <TableCell align="right">Country</TableCell>
                                <TableCell align="right">City</TableCell>
                                <TableCell align="right">Province</TableCell>
                                <TableCell align="right">Zip Code</TableCell>
                                <TableCell align="center">is Primary?</TableCell>
                                <TableCell align="center">is Manager?</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableRows.map((row, idx) => (
                                <TableRow
                                    key={idx}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.companyName}
                                    </TableCell>
                                    <TableCell align="right">{row.firstName}</TableCell>
                                    <TableCell align="right">{row.lastName}</TableCell>
                                    <TableCell align="right">{row.email}</TableCell>
                                    <TableCell align="right">{row.title}</TableCell>
                                    <TableCell align="right">{row.companyWebsite}</TableCell>
                                    <TableCell align="right">{row.primaryPhone}</TableCell>
                                    <TableCell align="right">{row.mobilePhone}</TableCell>
                                    <TableCell align="right">{row.streetAddress}</TableCell>
                                    <TableCell align="right">{row.country}</TableCell>
                                    <TableCell align="right">{row.city}</TableCell>
                                    <TableCell align="right">{row.province}</TableCell>
                                    <TableCell align="right">{row.zipCode}</TableCell>
                                    <TableCell align="center">
                                        {row.isAgencyPrimary ? 'True' : 'False'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.isAgencyManager ? 'True' : 'False'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {noAdvertisers ? (
                    <div
                        style={{
                            textAlign: 'center',
                            backgroundColor: 'white',
                        }}
                    >
                        There are no saved advertisers for this agency.
                    </div>
                ) : null}
                <StyledNavButtons>
                    <NextBtn
                        variant="contained"
                        color="primary"
                        onClick={() => setModalIsOpen(true)}
                    >
                        Add a new user
                    </NextBtn>
                </StyledNavButtons>
            </ViewUsersContainer>
            <AddUsersModal handleClose={handleClose} modalIsOpen={modalIsOpen} />
        </>
    );
};

ViewUsers.propTypes = {
    advertisers: propTypes.shape({
        advertiserList: propTypes.array,
        selectedAdvertiser: propTypes.shape({
            advertiserId: propTypes.number,
            stripeCustomerId: propTypes.string,
        }),
    }),
    profile: propTypes.shape({
        isAgency: propTypes.bool,
        isIndividual: propTypes.bool,
        isSiteAdmin: propTypes.bool,
    }),
    campaigns: propTypes.shape({
        linkedAdvertiserCampaigns: propTypes.array,
        selectedCampaign: propTypes.shape({
            dealName: propTypes.string,
        }),
    }),
};

ViewUsers.defaultProps = {
    advertisers: {},
    setAdvertisers: () => {},
    campaigns: { selectedCampaign: { dealName: '' } },
};
export default ViewUsers;
